/**
 * 创建插件形式的error
 * type:error的类型默认为error
 *                      
*/
function error(text) {
    var dom = document.createElement('div');
    dom.className = 'app-tui-error';
    dom.innerHTML = text;
    document.body.appendChild(dom);
    var time = setTimeout(function () {
        dom.remove();
        clearTimeout(time);
    }, 3000);
}
/**
 * 创建插件形式的toast
*/
function toast(text) {
    var dom = document.createElement('div');
    dom.className = 'app-tui-toast';
    dom.innerHTML = `<div>${text}</div>`;
    document.body.appendChild(dom);
    var time = setTimeout(function () {
        dom.remove();
        clearTimeout(time);
    }, 2000);
}

export { error, toast }


// WEBPACK FOOTER //
// ./src/components/plugin/toast.js